var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navbar Icon",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8071 7.41667C18.6821 7.16667 18.4238 7 18.1405 7H11.0905L11.8655 0.816667C11.9071 0.5 11.7321 0.183333 11.4321 0.0583333C11.3405 0.0166667 11.2405 0 11.1488 0C10.9321 0 10.7238 0.0916667 10.5821 0.258333L1.83212 10.7583C1.64878 10.975 1.61545 11.2833 1.73212 11.5333C1.84878 11.7917 2.11545 11.9583 2.39045 11.9583H9.44045L8.66545 18.1333C8.63212 18.4583 8.80712 18.7667 9.09878 18.9C9.39878 19.025 9.74878 18.9417 9.95712 18.6917L18.7071 8.19167C18.8821 7.975 18.9238 7.675 18.8071 7.41667ZM10.4238 15.85L10.9905 11.3167C11.0155 11.1083 10.9488 10.9 10.8155 10.7417C10.6738 10.5917 10.4738 10.5 10.2655 10.5H3.94878L10.1071 3.10833L9.54045 7.63333C9.51545 7.84167 9.58212 8.05 9.72378 8.20833C9.85712 8.36667 10.0571 8.45833 10.2655 8.45833H16.5821L10.4238 15.85Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.4cccb35e19f25da51db0bca58ec66bfe.svg";
export { ForwardRef as ReactComponent };